import { filter, isEmpty } from 'lodash';

import {
  QUESTION_PROMPT_MAX_LENGTH,
  ANSWER_MAX_LENGTH,
  ANSWER_DEFAULT,
} from 'containers/QuestionnairePage/constants';
import { isAnswerEmpty } from './utils';
import { VW_ANSWER_COUNT } from './constants';
import { getPromptFromHtml } from '../../../../components/FormattedInput/helpers';

const validate = ({ answers = [], prompt }) => {
  const defaultAnswers = filter(answers, ['type', ANSWER_DEFAULT]);
  const errors = { answerTooLong: {} };

  if (isEmpty(prompt)) {
    errors.missingPrompt = true;
  }

  const questionTooLong = prompt && prompt.length > QUESTION_PROMPT_MAX_LENGTH;
  if (questionTooLong) {
    errors.questionTooLong = true;
  }

  const validEmptyAnswers = filter(defaultAnswers, (answer) =>
    isAnswerEmpty(answer),
  );

  const hasMissingAnswers = answers.length < VW_ANSWER_COUNT;

  if (hasMissingAnswers) {
    errors.missingAnswers = true;
  }

  if (validEmptyAnswers.length > 0) {
    errors.emptyAnswers = true;
  }

  const hasTooManyAnswers = answers.length > VW_ANSWER_COUNT;

  if (hasTooManyAnswers) {
    errors.tooManyAnswers = true;
  }

  // answer prompt max length check
  answers.forEach((answer) => {
    if (getPromptFromHtml(answer.body).length > ANSWER_MAX_LENGTH) {
      errors.answerTooLong[answer.refId] = true;
    }
  });

  if (isEmpty(errors.answerTooLong)) {
    delete errors.answerTooLong;
  }

  return errors;
};

export default validate;
